export enum FileUploadSourceEnum {
    FormField = 1,
    UserProfile = 2,
}